import { FaBoxOpen } from "react-icons/fa";
import "./EmptyState.css";

function EmptyState({
  title = "No Data Found",
  subtitle = "Nothing to display.",
}) {
  return (
    <div className="empty-state">

      <FaBoxOpen className="empty-icon" />

      <h2>{title}</h2>

      <p>{subtitle}</p>

    </div>
  );
}

export default EmptyState;